import { createUseStyles } from 'react-jss';
import { ITheme } from '../theme';


type RuleNames =
  | 'buttonsContainer'
  | 'buttons';

const PREFIX = 'CropImage';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      buttonsContainer: {
        position: 'absolute',
        bottom: 10,
        right: 15,
        display: 'flex',
        cursor: 'pointer',
        justifyContent: 'space-around',
        width: '40px',
        height: '13px',
        padding: '4px',
        borderRadius: '5px',
        background: 'rgba(0, 0, 0, 0.5)',
      },
      buttons: {
        zIndex: 10,
        color: 'white',
      },
    }
  ),
  { name: PREFIX },
);
